import { Me } from "../../types/api-schema";
import { User } from "../app/propTypes";

import { SET_BROADCAST, SET_ME, SET_USER } from "./actions";

import type { OidcState } from "../../envConfig";

import type { OidcActionType } from "./actions";

export default function oidc(
  state: OidcState = { authComplete: false, user: null },
  action: { data: BroadcastChannel | Me | null | User; type: OidcActionType },
) {
  switch (action.type) {
    case SET_BROADCAST:
      return {
        ...state,
        broadcast: action.data as BroadcastChannel,
      };
    case SET_ME:
      return {
        ...state,
        me: action.data as Me,
      };
    case SET_USER:
      return {
        ...state,
        user: action.data as User,
      };
    default:
      return {
        ...state,
      };
  }
}
